import React, { useRef, useState } from 'react';
import { Loader2, Siren } from 'lucide-react';
import { toast } from 'sonner';
import { errMsg } from '../portal/api';
import { K, tapi } from './tapi';

const HOLD_MS = 2000;
const position = () => new Promise((ok) => {
  if (!navigator.geolocation) { ok(null); return; }
  navigator.geolocation.getCurrentPosition((p) => ok(p.coords), () => ok(null), { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 });
});

export default function SosButton() {
  const [prog, setProg] = useState(0);
  const [state, setState] = useState('idle');
  const timer = useRef(null);
  const send = async () => {
    setState('busy');
    const c = await position();
    try {
      await tapi.post('/sos', { lat: c?.latitude ?? null, lon: c?.longitude ?? null, accuracy: c?.accuracy ?? null, message: '' }, { headers: { 'X-SOS-Token': localStorage.getItem(K.sos) || '' } });
      setState('sent'); if (navigator.vibrate) navigator.vibrate([200, 100, 200]);
    } catch (e) { toast.error(errMsg(e)); setState('idle'); }
  };
  const start = () => {
    if (state !== 'idle') return;
    const t0 = Date.now();
    timer.current = setInterval(() => { const p = Math.min(1, (Date.now() - t0) / HOLD_MS); setProg(p); if (p >= 1) { clearInterval(timer.current); setProg(0); send(); } }, 40);
  };
  const stop = () => { clearInterval(timer.current); setProg(0); };
  if (state === 'sent') return (
    <div className="rounded-2xl border border-[#C2423A] bg-[#2A0D0B] p-5 text-center" data-testid="sos-sent">
      <p className="font-semibold text-lg mb-1">Richiesta di aiuto inviata</p>
      <p className="text-sm text-[#E5B5B0] mb-3">La tua azienda è stata avvisata con la tua posizione. Se puoi, chiama subito:</p>
      <a href="tel:+390636225" className="block h-12 leading-[3rem] rounded-xl bg-[#C2423A] font-semibold mb-2" data-testid="sos-call-farnesina">Unità di Crisi Farnesina · +39 06 36225</a>
      <a href="tel:112" className="block h-12 leading-[3rem] rounded-xl border border-[#C2423A] font-semibold" data-testid="sos-call-112">Numero di emergenza 112</a>
      <button onClick={() => setState('idle')} className="text-xs underline text-[#E5B5B0] mt-3">Chiudi</button>
    </div>
  );
  return (
    <div className="text-center">
      <button onPointerDown={start} onPointerUp={stop} onPointerLeave={stop} onContextMenu={(e) => e.preventDefault()} disabled={state === 'busy'}
        className="relative w-44 h-44 rounded-full mx-auto grid place-items-center select-none touch-none text-white font-bold text-xl shadow-[0_0_60px_-10px_#C2423A]"
        style={{ background: `conic-gradient(#FFFFFF ${prog * 360}deg, #C2423A 0deg)` }} data-testid="sos-button">
        <span className="absolute inset-2 rounded-full bg-[#C2423A] grid place-items-center">
          {state === 'busy' ? <Loader2 className="animate-spin" size={40} /> : <span className="flex flex-col items-center gap-1"><Siren size={40} />EMERGENZA</span>}
        </span>
      </button>
      <p className="text-xs text-[#A3A3A3] mt-3">Tieni premuto 2 secondi: avvisiamo subito la tua azienda con la tua posizione.</p>
    </div>
  );
}
